var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("page", { staticStyle: { background: "#fff" } }, [
    _c(
      "div",
      { staticClass: "text-center", staticStyle: { padding: "50px 0" } },
      [
        _c("div", { staticClass: "text-3xl font-bold text-gray-700" }, [
          _vm._v("欢迎使用"),
        ]),
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/assets/ap-logo.png") },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }